import { useState, useEffect } from "react";
import { SUBCRIPTION_TYPE_AND_DESCRIPTION } from "../../utils/constants";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface SubscriptionModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentType: string;
    onConfirm: (newType: string) => void;
}

export const SubscriptionModal = ({ isOpen, onClose, currentType, onConfirm }: SubscriptionModalProps) => {
    const [selected, setSelected] = useState(currentType);

    useEffect(() => { setSelected(currentType); }, [currentType]);

    if (!isOpen) return null;

    return (
        <div className="uem-overlay" onClick={onClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()}>
                <div className="uem-header">
                    <h2>Manage Subscription Type</h2>
                    <button className="uem-close" onClick={onClose} aria-label="Close modal">×</button>
                </div>
                <div className="uem-body">
                    <p className="uem-modal-desc">Changing subscription type takes effect immediately.</p>
                    <div className="uem-radio-cards">
                        {SUBCRIPTION_TYPE_AND_DESCRIPTION.map((opt) => (
                            <label key={opt.value} className={`uem-radio-card ${selected === opt.value ? "selected" : ""}`}>
                                <input type="radio" name="subType" value={opt.value} checked={selected === opt.value} onChange={() => setSelected(opt.value)} />
                                <div className="uem-radio-card-content">
                                    <div className="uem-radio-card-title">{opt.label}</div>
                                    {opt.value === "paused" ? (
                                        <div className="uem-radio-card-warn">Account paused due to non-payment — access suspended</div>
                                    ) : (
                                        <div className="uem-radio-card-desc">{opt.description}</div>
                                    )}
                                </div>
                            </label>
                        ))}
                    </div>
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={onClose}>Cancel</button>
                    <button type="button" className="uem-btn-submit" disabled={!selected} onClick={() => onConfirm(selected)}>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};
